define('modules/base/models/identity.profile.model',[
    'underscore',
    'backbone',
    'modules/base/models/identity.model',
], function (_, Backbone, IdentityModel) {
    var IdentityProfileModel = IdentityModel.extend({
        base: 'identity/profile',
        urlRoot:function(){
            this.set({id: undefined});
            if(this.get('source') != undefined ){
                var source = this.get('source');
                var identityType = this.get('identityType');
                var ext = '/' + identityType + '/' + source.sourceId + '/' + source.refId;

                if(this.has('searchId')){
                    ext += "?searchId=" +  this.get('searchId');
                }

                return window.utils.makeUrl('prospector/v1/' + this.base + ext);
            } else {
                return window.utils.makeUrl('prospector/v1/' + this.base);
            }
        }
    });
    return IdentityProfileModel;
});


